<template>
  <div class="drawPicture">
    <div>
      <van-tabs>
        <van-tab
          v-for="(item, index) of material"
          :title="item.name"
          :key="index"
        >
         <slot></slot>
          <div class="list">
            <ul >
              <li v-for="(item2, index2) of item.type" :key="index2" @click="chooseImg">
                <img :src="item2" />
              </li>
            </ul>
          </div>
        </van-tab>
       
        <div class="back"><button @click="back">上一步</button></div>
      </van-tabs>
    </div>
    <div>
      <ul></ul>
    </div>
  </div>
</template>
<script>
import { Tab, Tabs } from "vant";
export default {
    //  inheritAttrs: ,
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },
  data() {
    return {
      material: [
        {
          name: "花朵",
          type: [
            require("../../../../../../assets/gift/material/1.png"),
            require("../../../../../../assets/gift/material/2.png"),
            require("../../../../../../assets/gift/material/3.png"),
            require("../../../../../../assets/gift/material/4.png"),
            require("../../../../../../assets/gift/material/5.png"),
            require("../../../../../../assets/gift/material/6.png"),
            require("../../../../../../assets/gift/material/7.png"),
            require("../../../../../../assets/gift/material/8.png"),
          ],
        },
        {
          name: "节日",
          type: [
            require("../../../../../../assets/gift/material/1.png"),
            require("../../../../../../assets/gift/material/2.png"),
            require("../../../../../../assets/gift/material/3.png"),
            require("../../../../../../assets/gift/material/4.png"),
            require("../../../../../../assets/gift/material/5.png"),
            require("../../../../../../assets/gift/material/6.png"),
            require("../../../../../../assets/gift/material/7.png"),
            require("../../../../../../assets/gift/material/8.png"),
          ],
        },
        {
          name: "动物",
          type: [
            require("../../../../../../assets/gift/material/1.png"),
            require("../../../../../../assets/gift/material/2.png"),
            require("../../../../../../assets/gift/material/3.png"),
            require("../../../../../../assets/gift/material/4.png"),
            require("../../../../../../assets/gift/material/5.png"),
            require("../../../../../../assets/gift/material/6.png"),
            require("../../../../../../assets/gift/material/7.png"),
            require("../../../../../../assets/gift/material/8.png"),
          ],
        },
        {
          name: "季节",
          type: [
            require("../../../../../../assets/gift/material/1.png"),
            require("../../../../../../assets/gift/material/2.png"),
            require("../../../../../../assets/gift/material/3.png"),
            require("../../../../../../assets/gift/material/4.png"),
            require("../../../../../../assets/gift/material/5.png"),
            require("../../../../../../assets/gift/material/6.png"),
            require("../../../../../../assets/gift/material/7.png"),
            require("../../../../../../assets/gift/material/8.png"),
          ],
        },
        {
          name: "祝福",
          type: [
            require("../../../../../../assets/gift/material/1.png"),
            require("../../../../../../assets/gift/material/2.png"),
            require("../../../../../../assets/gift/material/3.png"),
            require("../../../../../../assets/gift/material/4.png"),
            require("../../../../../../assets/gift/material/5.png"),
            require("../../../../../../assets/gift/material/6.png"),
            require("../../../../../../assets/gift/material/7.png"),
            require("../../../../../../assets/gift/material/8.png"),
          ],
        },
        {
          name: "心悦",
          type: [
            require("../../../../../../assets/gift/material/1.png"),
            require("../../../../../../assets/gift/material/2.png"),
            require("../../../../../../assets/gift/material/3.png"),
            require("../../../../../../assets/gift/material/4.png"),
            require("../../../../../../assets/gift/material/5.png"),
            require("../../../../../../assets/gift/material/6.png"),
            require("../../../../../../assets/gift/material/7.png"),
            require("../../../../../../assets/gift/material/8.png"),
          ],
        },
      ],
    };
  },
  methods:{
      chooseImg(e){
        this.$emit('selectImg',e.target)
      },
      back(){
          this.$emit('quit',false)
      }
  }
};
</script>
<style lang="scss" scoped>
    .drawPicture{
        font-size: 0.12rem;
        .list{
            ul{
                text-align: center;        
                li{
                    width: 1.2rem;
                    margin: 0.1rem 0.3rem;
                    display: inline-block;
                }
            }
        }
       .back{
            text-align: center;
            margin-top: 0.6rem;
            button{
                font-size: 0.28rem;
                width: 4.68rem;
                height: 0.99rem;
                background: #FFC44E;
                border: none;
                border-radius: 30px;
                color: white;
            }
        }
    }
</style>